import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/directives/click-outside";

import "./scss/droopy-dropdown.scss";

import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.use(VueFriendlyIframe);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    window.addEventListener("keydown", this.preventBack);
  },
  methods: {
    preventBack(e) {
      // TODO improve (div[contenteditable="true"], different input types...)
      if (!["INPUT", "TEXTAREA"].includes(document.activeElement.nodeName)) {
        // 8 = backspace code
        if (e.keyCode === 8) {
          e.preventDefault();
        }
      }
    },
  },
}).$mount("#app");
